import { TabPanel } from "@chakra-ui/react";
import { UseFormReturn } from "react-hook-form";
import ControlledTabs from "components/Form/ControlledTabs";
import SecondaryTabButton from "components/Button/SecondaryTabButton";
import { TemplatePrefixId } from "features/Resources/SharedTemplate/models";
import { useMemo } from "react";
import { SharedTemplateSchema } from "features/Resources/SharedTemplate/schema";
import Timing from "./Timing";
import TaskCompletion from "./TaskCompletion";
import { TRIGGER_TYPE_FIELD } from "./fields";

export default function TemplateTriggerForm({
  form,
  fieldName,
  currentTemplatePrefixId,
  timingOnly = false,
  includeTimeOfDay = true,
  allowWeekendsFieldName,
  allowWeekendsReadOnly = false,
}: {
  form: UseFormReturn<SharedTemplateSchema>;
  fieldName: string;
  currentTemplatePrefixId?: TemplatePrefixId | undefined;
  timingOnly: boolean;
  includeTimeOfDay: boolean;
  allowWeekendsFieldName?: string;
  allowWeekendsReadOnly?: boolean;
}) {
  const { control, watch } = form;
  const paths = watch("paths");
  const pathIds = useMemo(() => (paths || []).map((path) => path?.id), [paths]);

  return timingOnly ? (
    <Timing<SharedTemplateSchema>
      form={form}
      fieldName={fieldName}
      timingOnly
      includeTimeOfDay={includeTimeOfDay}
      allowWeekendsFieldName={allowWeekendsFieldName}
      allowWeekendsReadOnly={allowWeekendsReadOnly}
    />
  ) : (
    <ControlledTabs
      variant="unstyled"
      customTab={SecondaryTabButton}
      control={control}
      name={`${fieldName}.type`}
      {...TRIGGER_TYPE_FIELD}
      tabListProps={{ spacing: "8px", gap: "8px", width: "100%" }}
    >
      <TabPanel paddingX={0}>
        <Timing<SharedTemplateSchema>
          form={form}
          fieldName={fieldName}
          includeTimeOfDay={includeTimeOfDay}
          allowWeekendsFieldName={allowWeekendsFieldName}
          allowWeekendsReadOnly={allowWeekendsReadOnly}
        />
      </TabPanel>
      <TabPanel paddingX={0}>
        <TaskCompletion
          fieldName={fieldName}
          form={form}
          pathIds={pathIds}
          currentTemplatePrefixId={currentTemplatePrefixId}
        />
      </TabPanel>
    </ControlledTabs>
  );
}
